// Mock data for the heat pump landing page

export const testimonials = [
  {
    id: 1,
    name: "Familie Weber",
    location: "Potsdam",
    text: "Seit der Installation unserer Wärmepumpe haben wir 75% unserer Heizkosten gespart. Die Montage war professionell und pünktlich.",
    rating: 5,
    image: "video-placeholder-1",
    savings: "75% Ersparnis"
  },
  {
    id: 2,
    name: "Herr Müller",
    location: "Brandenburg an der Havel",
    text: "Kompetente Beratung von Anfang bis Ende. Die Wärmepumpe läuft perfekt und wir können sogar im Sommer kühlen.",
    rating: 5,
    image: "video-placeholder-2",
    savings: "Kühlen + Heizen"
  },
  {
    id: 3,
    name: "Familie Schmidt",
    location: "Oranienburg",
    text: "Dank der staatlichen Förderung haben wir nur 30% selbst bezahlt. Beste Investition für unser Eigenheim!",
    rating: 5,
    image: "video-placeholder-3",
    savings: "70% Förderung"
  },
  {
    id: 4,
    name: "Frau Hoffmann",
    location: "Falkensee",
    text: "Auch im tiefsten Winter heizt unsere Wärmepumpe zuverlässig. Wir sind zu 100% unabhängig von Gas und Öl.",
    rating: 5,
    image: "video-placeholder-4",
    savings: "100% unabhängig"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Niedrige Betriebskosten",
    shortDesc: "Bis zu 80% weniger Heizkosten",
    fullDesc: "Wärmepumpen nutzen kostenlose Umweltenergie und wandeln diese hocheffizient in Heizwärme um. Dadurch entstehen bis zu 80% weniger Betriebskosten als bei herkömmlichen Gas- oder Ölheizungen.",
    icon: "DollarSign",
    color: "green"
  },
  {
    id: 2,
    title: "Klimafreundlich & CO₂-sparend",
    shortDesc: "0% lokale Emissionen",
    fullDesc: "Wärmepumpen produzieren keine lokalen Emissionen und reduzieren Ihren CO₂-Fußabdruck erheblich. Mit Ökostrom betrieben sind sie zu 100% klimaneutral.",
    icon: "Leaf",
    color: "green"
  },
  {
    id: 3,
    title: "Förderfähig bis 70%",
    shortDesc: "Bis zu 21.000€ Zuschuss",
    fullDesc: "Der Staat fördert den Einbau von Wärmepumpen mit bis zu 70% der Investitionskosten. Das entspricht einem Zuschuss von bis zu 21.000€ für Ihr Projekt.",
    icon: "Gift",
    color: "orange"
  },
  {
    id: 4,
    title: "Kühlen möglich",
    shortDesc: "Heizen & Kühlen in einem Gerät",
    fullDesc: "Moderne Wärmepumpen können nicht nur heizen, sondern im Sommer auch angenehm kühlen. Ein Gerät für ganzjährigen Komfort.",
    icon: "Snowflake",
    color: "green"
  },
  {
    id: 5,
    title: "Immobilienwert steigt",
    shortDesc: "Bis zu 15% Wertsteigerung",
    fullDesc: "Eine moderne Wärmepumpe steigert den Wert Ihrer Immobilie nachweislich um bis zu 15% und verbessert die Energieeffizienzklasse erheblich.",
    icon: "TrendingUp",
    color: "green"
  },
  {
    id: 6,
    title: "Unabhängig von Gas & Öl",
    shortDesc: "100% Versorgungssicherheit",
    fullDesc: "Mit einer Wärmepumpe machen Sie sich unabhängig von fossilen Brennstoffen und schwankenden Energiepreisen. Ihre Versorgungssicherheit ist garantiert.",
    icon: "Shield",
    color: "green"
  }
];

export const workShowcaseItems = [
  {
    id: 1,
    title: "Luft-Wasser-Wärmepumpe im Neubau",
    description: "Effiziente Lösung für ein modernes Einfamilienhaus mit 150m² Wohnfläche. Heizung und Warmwasser aus einer Hand.",
    location: "Potsdam",
    benefit: "Niedrige Betriebskosten",
    image: "work-placeholder-1",
    specs: "12 kW Heizleistung, COP 4.5"
  },
  {
    id: 2,
    title: "Erdwärmepumpe bei Altbausanierung", 
    description: "Komplette Heizungsmodernisierung eines 70er Jahre Hauses. Perfekte Integration in bestehende Heizkörper.",
    location: "Brandenburg",
    benefit: "Klimafreundlich & CO₂-sparend",
    image: "work-placeholder-2",
    specs: "16 kW Heizleistung, JAZ 4.8"
  },
  {
    id: 3,
    title: "Hybrid-Wärmepumpe mit Solar",
    description: "Kombination aus Wärmepumpe und Photovoltaikanlage für maximale Effizienz und Unabhängigkeit.",
    location: "Oranienburg",
    benefit: "Förderfähig bis 70%",
    image: "work-placeholder-3",
    specs: "10 kW Wärmepumpe + 8 kWp Solar"
  },
  {
    id: 4,
    title: "Kühlfunktion für Sommermonate",
    description: "Wärmepumpe mit aktiver Kühlung sorgt ganzjährig für perfektes Raumklima in diesem Einfamilienhaus.",
    location: "Falkensee",
    benefit: "Kühlen möglich",
    image: "work-placeholder-4",
    specs: "14 kW Heizen, 8 kW Kühlen"
  },
  {
    id: 5,
    title: "Split-Wärmepumpe für Stadthaus",
    description: "Platzsparende Lösung für ein Reihenhaus mit begrenztem Außenbereich. Innen- und Außengerät optimal positioniert.",
    location: "Berlin-Spandau",
    benefit: "Immobilienwert steigt",
    image: "work-placeholder-5",
    specs: "8 kW Heizleistung, leiser Betrieb"
  }
];

// Monatliche Aktionen - dynamisch basierend auf dem aktuellen Monat
export const getMonthlyAction = () => {
  const now = new Date();
  const currentMonth = now.getMonth(); // 0 = Januar, 11 = Dezember
  
  const monthlyActions = [
    { // Januar
      title: "Neujahrs-Aktion 2025",
      subtitle: "Starten Sie energieeffizient ins neue Jahr & erhalten Sie GRATIS Energieberatung",
      description: "Nur im Januar 2025 erhalten Sie zu jeder beauftragten Wärmepumpe eine kostenlose, umfassende Energieberatung für Ihr gesamtes Zuhause. Zusätzlich übernehmen wir die komplette Förderantragsstellung und bieten Ihnen eine Neujahrs-Festpreisgarantie bis zum Sommer.",
      gift: "Kostenlose Energieberatung im Wert von 450€"
    },
    { // Februar  
      title: "Valentins-Aktion 2025",
      subtitle: "Schenken Sie Ihrem Zuhause Wärme & erhalten Sie GRATIS Wartungspaket",
      description: "Nur im Februar 2025 erhalten Sie zu jeder beauftragten Wärmepumpe ein kostenloses 3-Jahres-Wartungspaket. Zeigen Sie Ihrem Zuhause Liebe mit einer effizienten Wärmepumpe und profitieren Sie von unserem Valentins-Sonderangebot.",
      gift: "3-Jahres-Wartungspaket im Wert von 650€"
    },
    { // März
      title: "Frühjahrs-Aktion 2025", 
      subtitle: "Frühjahrsputz für Ihre Heizung & GRATIS Heizkostenanalyse",
      description: "Nur im März 2025 erhalten Sie zu jeder beauftragten Wärmepumpe eine kostenlose, detaillierte Analyse Ihrer aktuellen Heizkosten und des Einsparpotentials. Der perfekte Start in die wärmere Jahreszeit mit maximaler Effizienz.",
      gift: "Kostenlose Heizkostenanalyse im Wert von 350€"
    },
    { // April
      title: "Osteraktion 2025",
      subtitle: "Neue Energie für Ihr Zuhause & GRATIS Smart-Home-Paket",
      description: "Nur im April 2025 erhalten Sie zu jeder beauftragten Wärmepumpe ein kostenloses Smart-Home-Paket zur intelligenten Steuerung Ihrer Heizung. Erwecken Sie Ihr Zuhause zu neuem Leben mit modernster Wärmepumpen-Technologie.",
      gift: "Smart-Home-Steuerungspaket im Wert von 780€"
    },
    { // Mai
      title: "Maibaum-Aktion 2025",
      subtitle: "Wachsen Sie über sich hinaus & erhalten Sie GRATIS Photovoltaik-Beratung", 
      description: "Nur im Mai 2025 erhalten Sie zu jeder beauftragten Wärmepumpe eine kostenlose Photovoltaik-Beratung für die perfekte Kombination aus Wärmepumpe und Solarenergie. Lassen Sie Ihre Energiekosten wie einen Maibaum in die Höhe wachsen - aber rückwärts!",
      gift: "Photovoltaik-Beratung & Planung im Wert von 550€"
    },
    { // Juni
      title: "Sommer-Aktion 2025",
      subtitle: "Kühlen Kopf bewahren & GRATIS Klimafunktion-Upgrade",
      description: "Nur im Juni 2025 erhalten Sie zu jeder beauftragten Wärmepumpe ein kostenloses Upgrade auf die aktive Kühlfunktion. Perfekt für heiße Sommertage - Ihre Wärmepumpe wird zur Klimaanlage und sorgt ganzjährig für Wohlfühltemperatur.",
      gift: "Aktive Kühlfunktion im Wert von 1.200€"
    },
    { // Juli  
      title: "Hochsommer-Aktion 2025",
      subtitle: "Heißer Deal für coole Köpfe & GRATIS Sommerwartung",
      description: "Nur im Juli 2025 erhalten Sie zu jeder beauftragten Wärmepumpe eine kostenlose Sommerwartung und Optimierung für die Kühlsaison. Nutzen Sie die heißesten Tage des Jahres für die coolste Investition - Ihre neue Wärmepumpe.",
      gift: "Sommer-Wartung & Kühl-Optimierung im Wert von 380€"  
    },
    { // August
      title: "Ernte-Aktion 2025",
      subtitle: "Ernten Sie Ihre Ersparnisse & erhalten Sie GRATIS Effizienz-Check",
      description: "Nur im August 2025 erhalten Sie zu jeder beauftragten Wärmepumpe einen kostenlosen jährlichen Effizienz-Check für optimale Leistung. Ernten Sie die Früchte moderner Heiztechnik und maximaler Energieeffizienz.",
      gift: "Jährlicher Effizienz-Check im Wert von 290€"
    },
    { // September
      title: "Herbst-Aktion 2025", 
      subtitle: "Goldener Herbst für Ihre Heizung & GRATIS Wintervorbereitung",
      description: "Nur im September 2025 erhalten Sie zu jeder beauftragten Wärmepumpe eine kostenlose Wintervorbereitung und Systemoptimierung. Bereiten Sie Ihr Zuhause optimal auf die kalte Jahreszeit vor.",
      gift: "Wintervorbereitung & Systemcheck im Wert von 420€"
    },
    { // Oktober
      title: "Halloween-Aktion 2025",
      subtitle: "Vertreiben Sie hohe Heizkosten & erhalten Sie GRATIS Nachtabsenkung",
      description: "Nur im Oktober 2025 erhalten Sie zu jeder beauftragten Wärmepumpe eine kostenlose Programmierung der intelligenten Nachtabsenkung. Erschrecken Sie Ihre Heizkosten zu Tode - aber Ihre Wärmepumpe arbeitet leise wie ein Geist.",
      gift: "Intelligente Nachtabsenkung im Wert von 320€"
    },
    { // November
      title: "Vorwinter-Aktion 2025",
      subtitle: "Warme Gedanken für kalte Tage & GRATIS Frostschutz-Paket", 
      description: "Nur im November 2025 erhalten Sie zu jeder beauftragten Wärmepumpe ein kostenloses Frostschutz-Paket und Winteroptimierung. Machen Sie Ihr Zuhause fit für den Winter mit der zuverlässigsten Heiztechnik.",
      gift: "Frostschutz-Paket & Winteroptimierung im Wert von 490€"
    },
    { // Dezember
      title: "Weihnachts-Aktion 2025",
      subtitle: "Das schönste Geschenk für Ihr Zuhause & GRATIS Weihnachtsbonus",
      description: "Nur im Dezember 2025 erhalten Sie zu jeder beauftragten Wärmepumpe einen besonderen Weihnachtsbonus: Kostenlose Expressmontage zwischen den Jahren. Bescheren Sie sich und Ihrer Familie das Geschenk der Energieunabhängigkeit.",
      gift: "Express-Montage zwischen den Jahren im Wert von 800€"
    }
  ];
  
  return monthlyActions[currentMonth];
};

export const getTimeUntilEndOfMonth = () => {
  const now = new Date();
  const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
  const timeLeft = endOfMonth.getTime() - now.getTime();
  
  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
  return { days, hours, minutes, seconds, totalMs: timeLeft };
};

export const companyAdvantages = [
  {
    title: "Voller Lagerbestand, keine Wartezeiten",
    description: "Alle gängigen Wärmepumpen-Modelle direkt verfügbar"
  },
  {
    title: "Qualitätsführer aus Brandenburg", 
    description: "Über 13 Jahre Erfahrung und 2.000+ erfolgreiche Projekte"
  },
  {
    title: "Schnelle & zuverlässige Montage",
    description: "Professionelle Installation durch zertifizierte Meisterbetrieb"
  },
  {
    title: "Persönliche Beratung vor Ort",
    description: "Individuelle Planung und maßgeschneiderte Lösungen"
  }
];

// Mock form submission function
export const submitLeadForm = async (formData) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  console.log("Mock form submission:", formData);
  
  // Store in localStorage for demo purposes
  const existingLeads = JSON.parse(localStorage.getItem('heatPumpLeads') || '[]');
  const newLead = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString(),
    status: 'new',
    source: formData.leadType === 'qualified' ? 'qualification-form' : 'simple-form'
  };
  
  existingLeads.push(newLead);
  localStorage.setItem('heatPumpLeads', JSON.stringify(existingLeads));
  
  return {
    success: true,
    message: formData.leadType === 'qualified' 
      ? "Vielen Dank! Unser Experte meldet sich innerhalb von 24 Stunden bei Ihnen mit einem maßgeschneiderten Angebot."
      : "Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
    leadId: newLead.id,
    qualificationScore: formData.qualificationScore || 0
  };
};